// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as UrlUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.mjs";
import * as CommonStore$PorterinFeature from "../../../enterprise/domain/store/CommonStore.mjs";
import * as CommonHelper$PorterinFeature from "../../../../shared/core/helpers/CommonHelper.mjs";
import * as FareEstimateHelper$PorterinFeature from "../../../../shared/core/helpers/FareEstimateHelper.mjs";
import * as EventsTrackerHelper$PorterinFeature from "../../../../shared/core/helpers/EventsTrackerHelper.mjs";
import * as FareEstimateStoreV1$PorterinFeature from "../store/FareEstimateStoreV1.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../../shared/core/helpers/PublishEventsHelper.mjs";
import * as FareEstimateFormStore$PorterinFeature from "../../../../shared/core/constants/FareEstimateFormStore.mjs";
import * as FareEstimateAnalyticsHelper$PorterinFeature from "./FareEstimateAnalyticsHelper.mjs";
import * as FareEstimateResultFormHelperV1$PorterinFeature from "./FareEstimateResultFormHelperV1.mjs";
import * as FareEstimateResultQueryParamsV1$PorterinFeature from "../types/FareEstimateResultQueryParamsV1.mjs";

function getFareEstimateFormPayload(params) {
  return {
          GTES_mobile: params.mobile,
          GTES_city: Belt_Option.getWithDefault(params.user_city, ""),
          GTES_category: params.service_category,
          GTES_parameter: Belt_Option.getWithDefault(params.user_city, "") + "_" + params.mobile + "_" + params.service_category + "_" + params.frequency,
          GTES_frequency: params.frequency
        };
}

function publishFareEstimateSuccessfulEventParameter(params) {
  EventsTrackerHelper$PorterinFeature.publishEventParameter(FareEstimateStoreV1$PorterinFeature.ga_fare_estimate_successful_event_parameter, getFareEstimateFormPayload(params));
}

function submitButtonGaEvent(category, requirement) {
  switch (requirement) {
    case /* TwoWheelers */0 :
        return FareEstimateFormStore$PorterinFeature.form_submit_ga_event_prefix + (
                category === "Home" ? category + " 2W" : "2 wheeler"
              );
    case /* Trucks */1 :
        return FareEstimateFormStore$PorterinFeature.form_submit_ga_event_prefix + (
                category === "Home" ? category + " Trucks" : "trucks"
              );
    case /* PackersAndMovers */2 :
        return FareEstimateFormStore$PorterinFeature.form_submit_ga_event_prefix + category + " PNM";
    case /* Courier */3 :
        return FareEstimateFormStore$PorterinFeature.form_submit_ga_event_prefix + category + " Courier";
    
  }
}

function publishGtesEvent(category, payload) {
  PublishEventsHelper$PorterinFeature.publishEvents(category, FareEstimateStoreV1$PorterinFeature.ga_fare_estimate_successful, "1_" + payload.name + "#2_" + payload.mobile + "#3_frequency-" + payload.frequency + "#4_" + payload.utm_source + "#5_" + payload.utm_campaign + "#6_" + payload.service_category);
}

function getGtesUnregisteredPayload(params) {
  return {
          GTES_UR_mobile: params.mobile,
          GTES_UR_city: Belt_Option.getWithDefault(params.user_city, ""),
          GTES_UR_category: params.service_category,
          GTES_UR_parameter: Belt_Option.getWithDefault(params.user_city, "") + "_" + params.mobile + "_" + params.service_category + "_" + params.frequency,
          GTES_UR_frequency: params.frequency
        };
}

function publishGtesUnregisteredEvent(payload) {
  EventsTrackerHelper$PorterinFeature.publishEventParameter(FareEstimateStoreV1$PorterinFeature.gtes_unregistered_action_name, getGtesUnregisteredPayload(payload));
}

function fireUnregEventIfCustNotExist(parameters, send_unregistered_event_flag) {
  if (send_unregistered_event_flag) {
    return EventsTrackerHelper$PorterinFeature.publishEventParameter(FareEstimateStoreV1$PorterinFeature.gtes_unregistered_action_name, getGtesUnregisteredPayload(parameters));
  }
  
}

function fireGTEEventsOnLeadCreated(redirect_url, service_category, category, source, send_unregistered_event_flag) {
  var params = FareEstimateHelper$PorterinFeature.getUtmKeyValues(source);
  params.push([
        "service_category",
        service_category
      ]);
  var fare_estimate_parameters = FareEstimateResultFormHelperV1$PorterinFeature.getFareEstimateFormParameter(FareEstimateResultQueryParamsV1$PorterinFeature.queryMapper(UrlUtils$Catalyst.getURLParams(CommonHelper$PorterinFeature.addParamsToUrl(redirect_url, params))));
  EventsTrackerHelper$PorterinFeature.publishEventParameter(FareEstimateStoreV1$PorterinFeature.ga_fare_estimate_successful_event_parameter, getFareEstimateFormPayload(fare_estimate_parameters));
  publishGtesEvent(category, fare_estimate_parameters);
  fireUnregEventIfCustNotExist(fare_estimate_parameters, send_unregistered_event_flag);
}

function ctaClickEventParameter(event_name, moengage_parameter_event_name, address_context, selected_vehicle, selected_vehicle_fare, mobile) {
  EventsTrackerHelper$PorterinFeature.publishEventParameter(event_name, {
        fe_estresult_cta_confirm_tap_parameter: "" + address_context.sender.pickup_address.landmark + "_" + address_context.receiver.drop_address.landmark + "_" + String(selected_vehicle) + "_" + selected_vehicle_fare + "_" + FareEstimateStoreV1$PorterinFeature.location_accuracy_tg + ""
      });
  EventsTrackerHelper$PorterinFeature.publishEventParameter(moengage_parameter_event_name, FareEstimateAnalyticsHelper$PorterinFeature.getFareSelectedCardVersionEventPayload(mobile));
}

function getFareEstimateFormErrorPayload(field_errors) {
  return {
          pickup_error: Belt_Option.getWithDefault(field_errors.pickup, ""),
          drop_error: Belt_Option.getWithDefault(field_errors.drop, ""),
          name_error: Belt_Option.getWithDefault(field_errors.name, ""),
          mobile_error: Belt_Option.getWithDefault(field_errors.mobile, ""),
          requirement_error: Belt_Option.getWithDefault(field_errors.requirement, "")
        };
}

function publishFareEstimateFormErrorParameter(response) {
  var field_errors;
  if (response.TAG === /* FareEstimateHashError */0) {
    field_errors = {
      pickup: undefined,
      drop: undefined,
      name: undefined,
      mobile: undefined,
      requirement: undefined
    };
  } else {
    var err = response._0.field_errors;
    field_errors = err !== undefined ? err : ({
          pickup: undefined,
          drop: undefined,
          name: undefined,
          mobile: undefined,
          requirement: undefined
        });
  }
  EventsTrackerHelper$PorterinFeature.publishEventParameter(CommonStore$PorterinFeature.ga_fare_estimate_form_validation_error, getFareEstimateFormErrorPayload(field_errors));
}

function getFareEstimateFormErrorPayload$1(field_errors) {
  return {
          pickup_error: Belt_Option.getWithDefault(field_errors.pickup, ""),
          drop_error: Belt_Option.getWithDefault(field_errors.drop, ""),
          name_error: Belt_Option.getWithDefault(field_errors.name, ""),
          mobile_error: Belt_Option.getWithDefault(field_errors.mobile, ""),
          requirement_error: Belt_Option.getWithDefault(field_errors.requirement, "")
        };
}

function publishFareEstimateFormErrorParameterV2(response) {
  var field_errors;
  if (response.TAG === /* FareEstimateHashError */0) {
    field_errors = {
      pickup: undefined,
      drop: undefined,
      name: undefined,
      mobile: undefined,
      requirement: undefined
    };
  } else {
    var err = response._0.field_errors;
    field_errors = err !== undefined ? err : ({
          pickup: undefined,
          drop: undefined,
          name: undefined,
          mobile: undefined,
          requirement: undefined
        });
  }
  EventsTrackerHelper$PorterinFeature.publishEventParameter(FareEstimateStoreV1$PorterinFeature.ga_fare_estimate_form_validation_error, getFareEstimateFormErrorPayload$1(field_errors));
}

export {
  getFareEstimateFormPayload ,
  publishFareEstimateSuccessfulEventParameter ,
  submitButtonGaEvent ,
  publishGtesEvent ,
  getGtesUnregisteredPayload ,
  publishGtesUnregisteredEvent ,
  fireUnregEventIfCustNotExist ,
  fireGTEEventsOnLeadCreated ,
  ctaClickEventParameter ,
  publishFareEstimateFormErrorParameter ,
  getFareEstimateFormErrorPayload$1 as getFareEstimateFormErrorPayload,
  publishFareEstimateFormErrorParameterV2 ,
}
/* CommonHelper-PorterinFeature Not a pure module */
